import * as React from 'react';
import AppContext from 'contexts/App';

const { useContext } = React;

const useApp = () => useContext(AppContext);

export default useApp;
